import { type ApmBase, init as apmInit } from '@elastic/apm-rum';
import {
  apmRumIdPlaceholders,
  apmRumRemoveIgnored,
  ignoredPatterns,
} from 'utils/apm-utils';
import { envVariables } from 'utils/environment';

const createApmRum = (): ApmBase | undefined => {
  if (
    typeof window !== 'undefined' &&
    envVariables &&
    envVariables.apmServerUrl
  ) {
    /**
     * Total sample rate is combination of two options: active and transactionSampleRate.
     * Total rate = apmSampleRate * apmSampleRate (for example 0.1 * 0.1 = 0.01)
     */

    const apmSampleRate = Number(envVariables.apmSampleRate) || 1;

    const apm = apmInit({
      serviceName: 'areena-web-items',
      active: Math.random() < apmSampleRate,
      serverUrl: envVariables.apmServerUrl,
      environment: envVariables.environment || '',
      serviceVersion: envVariables.versionNumber || '',
      transactionSampleRate: apmSampleRate,
      distributedTracingOrigins: [
        'https://areena.api-test.yle.fi',
        'https://areena.api.yle.fi',
        'https://player.api-test.yle.fi',
        'https://player.api.yle.fi',
      ],
      ignoreTransactions: ignoredPatterns,
    });
    // cast at the call sites since the library's types don't match its documented runtime behavior
    apm.addFilter(apmRumRemoveIgnored as Parameters<typeof apm.addFilter>[0]);
    apm.addFilter(apmRumIdPlaceholders as Parameters<typeof apm.addFilter>[0]);
    return apm;
  }
};

export function init(): void {
  apmRum = createApmRum();
}

export let apmRum: ApmBase | undefined;
